export default {"src":"/_next/static/media/Group 48097640.d2f7eb62.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};